export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list-icon.vue?vue&type=template&id=e3967c72&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/leads/icons/list-icon.vue?vue&type=template&id=e3967c72&
// module id = 1172
// module chunks = 0